import { render, staticRenderFns } from "./emergencySuppliesTable.vue?vue&type=template&id=cda10e8e&scoped=true&"
import script from "./emergencySuppliesTable.vue?vue&type=script&lang=js&"
export * from "./emergencySuppliesTable.vue?vue&type=script&lang=js&"
import style0 from "./emergencySuppliesTable.vue?vue&type=style&index=0&id=cda10e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda10e8e",
  null
  
)

export default component.exports